import { render } from "./ClinicalHistoryList.vue?vue&type=template&id=7cd788df&scoped=true"
import script from "./ClinicalHistoryList.vue?vue&type=script&lang=js"
export * from "./ClinicalHistoryList.vue?vue&type=script&lang=js"

import "./ClinicalHistoryList.vue?vue&type=style&index=0&id=7cd788df&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cd788df"]])

export default __exports__